import { useRepubContext } from '@cx-web/feature-repub';

import styles from './Tabs.module.css';
export { styles as tabStyles };

export type TabName = 'Best Odds' | 'Offers' | 'Stats' | 'Match Stats' | 'Tips';
export type TabType = 'Tab' | 'Link';
export type TabElement = {
  content?: JSX.Element;
  dataTestId?: string;
  disabled?: boolean;
  name: TabName;
  type: TabType;
};

export interface TabProps {
  handleTabChange: (tabElement: TabElement) => void;
  selectedTab: TabElement;
  tabElements: TabElement[];
}

export const Tabs = ({ handleTabChange, selectedTab, tabElements }: TabProps) => {
  const { repubIs } = useRepubContext();
  const stylesRef = repubIs.OC ? 'oc' : 'default';
  const tabsContainerClassNames = [styles.tabsContainer, styles[stylesRef]].join(' ');

  return (
    <div className={tabsContainerClassNames} data-testid="tabs">
      {tabElements.map(tabElement => {
        const isActive = selectedTab.name === tabElement.name;
        const isLink = tabElement.type === 'Link';

        const tabClassNames = [
          styles.tab,
          styles[stylesRef],
          isActive ? styles.active : '',
          isLink ? styles.link : '',
        ].join(' ');

        const TabUI = isLink ? 'span' : 'button';

        return (
          <TabUI
            className={tabClassNames}
            data-testid={tabElement.dataTestId || 'tab-ui'}
            key={tabElement.name}
            onClick={() => handleTabChange(tabElement)}
          >
            {tabElement.content || tabElement.name}
          </TabUI>
        );
      })}
    </div>
  );
};
